import * as React from 'react';
import injectSheet from 'react-jss';
import { Spin, Icon, Upload } from 'antd';
import { handleXLSXFile } from 'src/utils/utils';
import { UploadChangeParam } from 'antd/lib/upload';
import CSVIcon from './icons/CSVIcon';
import { UploadFile } from 'antd/lib/upload/interface';

const Dragger = Upload.Dragger;

const styles = (theme: any) => ({

});

class ExcelUpload extends React.PureComponent<any, any> {
  temp: UploadFile[] = [];

  constructor(props) {
    super(props);
  }

  state = {
    fileList: this.temp,
    isDownloading: false,
  };

  handleUploadChange = (info: UploadChangeParam) => {
    const status = info.file.status;
    if (status === 'done') {
      this.onFileRecieved(info.file.originFileObj);
    }
    if (status !== 'removed') {
      this.setState({
        fileList: [info.file],
      });
    }
  }

  removeFile = () => {
    this.setState(
      {
        fileList: [],
      },
      () => {
        this.props.onDataParsed(null);
        if (this.props.onFileSelected) {
          this.props.onFileSelected(null);
        }
      },
    );
  }

  customRequest = ({ onSuccess, onError, file }) => {
    if (this.props.tempUploadStart) {
      this.props.tempUploadStart();
    }
    setTimeout(() => {
      onSuccess(null, file);
    }, 100);
  }

  onFileRecieved = async (file) => {
    const { mapping, mapping2, onDataParsed, parseData, fileName, fileName2, range, onFileSelected } = this.props;
    if (onFileSelected) {
      onFileSelected(file);
    }
    let sheet2DataList: any[] = [];
    const containerDataList: any[] = mapping
      ? await handleXLSXFile(file, Object.keys(mapping), parseData, fileName, range)
      : await handleXLSXFile(file, undefined, parseData, fileName, 0); // c7188fdf5e194359ae46d74f96879f19
    if (fileName2?.length) {
      sheet2DataList =
        mapping2 && Object.keys(mapping2).length
          ? await handleXLSXFile(file, Object.keys(mapping2), parseData, fileName2, range)
          : [];
    }
    if (this.props.tempUploadEnd) {
      this.props.tempUploadEnd();
    }
    if (onDataParsed) {
      onDataParsed(containerDataList);
      if (fileName2?.length) {
        onDataParsed(sheet2DataList, true);
      }
    }
  }

  uploadProps = {
    accept: this.props.fileType === 'excel' ? '.xlsx, .xls' : '.csv',
    name: 'file',
    multiple: false,
    customRequest: this.customRequest,
  };

  handleSampleDownload = () => {
    const { sampleLinkDownload } = this.props;
    const { isDownloading } = this.state;
    if (isDownloading) return;
    this.setState(
      {
        isDownloading: true,
      },
      async () => {
        await sampleLinkDownload();
        this.setState({
          isDownloading: false,
        });
      },
    );
  }

  render() {
    const { sampleLink, customMessage, headerText, fileType, sampleLinkInfoText } = this.props;
    const { fileList, isDownloading } = this.state;

    return (
      <div style={{ padding: '16px' }}>
        <Dragger
          fileList={fileList}
          style={{ padding: '16px' }}
          onChange={this.handleUploadChange}
          onRemove={this.removeFile}
          showUploadList={{ showRemoveIcon: true, showDownloadIcon: false }}
          {...this.uploadProps}
        >
          <p style={{ marginBottom: 24, fontSize: '14px' }} className="ant-upload-hint">
            {headerText || 'Upload a csv file to upload multiple shipments.'}
          </p>
          <p className="ant-upload-drag-icon">
            {fileType === 'excel' ? (
              <Icon type="file-excel" style={{ fontSize: '4.3em', color: '#00000073' }} />
            ) : (
              <CSVIcon width="1.3em" height="1.3em"></CSVIcon>
            )}
          </p>
          <p style={{ color: '#525252', marginBottom: 24 }} className="ant-upload-text">
            <b>
              Drag and drop to upload or <br></br>
              <span style={{ color: '#1890FF' }}>browse</span> to choose file
            </b>
          </p>
        </Dragger>
        {customMessage ? (
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: 24 }}>
            {customMessage}
          </div>
        ) : (
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: 24 }}>
            {sampleLink ? (
              <a href={sampleLink} target={'_blank'}>
                {sampleLinkInfoText || 'Download a sample file'}
              </a>
            ) : (
              <a onClick={this.handleSampleDownload}>
                {isDownloading ? 'Downloading in progress' : (sampleLinkInfoText || 'Download a sample file')}
              </a>
            )}
            {isDownloading ? (
              <Spin
                indicator={
                  <Icon type="loading" style={{ fontSize: '20px', marginLeft: '10px' }} spin />
                }
              />
            ) : null}
          </div>
        )}
      </div>
    );
  }
}

export default injectSheet(styles)(ExcelUpload);
